import { Box, Text } from '@chakra-ui/react';

interface CopyrightProps {
  mt?: number[];
  fontSize?: number;
}

export const Copyright = ({ mt = [0, 0, 4, 8], fontSize = 14 }: CopyrightProps) => {
  return (
    <Box className="footer" mt={mt} fontSize={fontSize}>
      <Text color="gray.500">
        © <Text as="span" display={{ base: 'none', sm: 'inline' }}>designed by </Text>
        <a 
          href="https://x.com/planetariumhq" 
          style={{
            textDecoration: "underline", 
            color: "gray.500"
          }}
        >
          Planetarium Labs
        </a>
      </Text>
    </Box>
  );
}; 